// isSuccessStatus returns true if status_code is (200, 204, etc.)
export function isSuccessStatus(httpStatusCode) {
  return Math.floor(httpStatusCode / 100) === 2;
}

export const handleRespPromise = resp =>
  resp.status === 200
    ? Promise.resolve()
    : Promise.reject(new HttpError(`Call Failed with status ${resp.status}`));

export class HttpError extends Error {
  constructor(message) {
    super(message);
    this.name = "HttpError";
  }
}
